/* eslint-disable */
import config from '../../../config'
import { useContext, useEffect, useState, useLayoutEffect } from 'react'
import { Button } from '../../../components/core/button'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { PageContext } from '../../../context/PageContextProvider'
import translate from '../../../utils/translate'
import SlidesAPI from '../../../api/slides'
import Loading from '../../../components/pages/loading'
import './styles.css'
import { Autoplay, Pagination, Navigation } from 'swiper'

const Slide = () => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [data, setData] = useState(false)
  const [width, setWidth] = useState(false)
  const [current, setCurrent] = useState(0)
  const linkBuilder = (url) => {
    if (!url) return ''
    return url.startsWith('http') ? url : config.API_URL + url
  }
  useEffect(() => {
    (async () => {

    const { data } = await SlidesAPI.getAll()
    await setData(data)
    await setLoad(true)
  
    })();
  }, [])
  const generateLink = (type) => {
    switch (type) {
      case 'news':
        return '/news'
      case 'careers':
        return '/careers'
      case 'services':
        return '/services/1'
      case 'journal':
        return '/magazine'
      case 'personal':
        return '/personal'
      case 'bussines':
        return `/bussines-consulting`
      case 'join':
        return `/join-our-family`
      case 'team':
        return '#'
      case 'about':
        return '/about'
      default:
        return '/'
    }
  }
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) {
        setWidth(true)
        return
      }
      setWidth(false)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])

  if (!load) return <Loading />
  if (!data || !Array.isArray(data) || data.length === 0) return null

  return (
    <section>
      <Swiper
        pagination={{
          clickable: true,
        }}
        loop={true}
        autoplay={{
          delay: data[current]?.seconds > 100 ? data[current].seconds : (data[current]?.seconds || 5) * 1000,
          disableOnInteraction: false,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        onSlideChange={(e) => {
          setCurrent(e.realIndex)
          let video = document.querySelectorAll('.slide-video')
          video.forEach((item) => {
            try {
              item.currentTime = 0
              item.play().catch(() => {})
            } catch (err) {}
          })
        }}
        className="slide-swiper"
      >
        {data.map((item, i) => {
          const mediaUrl = (width && item?.mobileLocation) ? item.mobileLocation : item.photoLocation;
          const isVideoMedia = item.isVideo || (mediaUrl && (mediaUrl.endsWith('.mp4') || mediaUrl.endsWith('.webm') || mediaUrl.includes('.mp4')));

          return (
            <SwiperSlide key={item._id || i}>
              {isVideoMedia ? (
                <video
                  className="slide-video"
                  src={linkBuilder(mediaUrl)}
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : (
                <img
                  src={linkBuilder(mediaUrl)}
                  alt={item.title ? item.title[language] : 'Slide'}
                />
              )}

            <div>
              {item?.title && (
                <h1
                  style={{
                    color:
                      item.title_color && !width ? item.title_color : '#1b1314',
                    backgroundColor:
                      item.title_bg && !width ? 'rgb(0,0,0,0.5)' : null,
                    padding: item.title_bg && !width ? '8px' : null,
                  }}
                >
                  {item.title?.[language] || ''}
                </h1>
              )}
              {(item.description_az || item.description_eng || item.description_ru) && (
                <p
                  style={{
                    color:
                      item.description_color && !width
                        ? item.description_color
                        : '#7C7C7C',
                    backgroundColor:
                      item.description_bg && !width ? 'rgb(0,0,0,0.5)' : null,
                    padding: item.description_bg && !width ? '8px' : null,
                  }}
                  dangerouslySetInnerHTML={{
                    __html:
                      language === 'AZ'
                        ? item?.description_az || ''
                        : language === 'TR'
                        ? item?.description_tr || item?.description_az || ''
                        : language === 'ENG'
                        ? item?.description_eng || ''
                        : item?.description_ru || '',
                  }}
                />
              )}
              {!item.DontShowButton && (
                <Button
                  top={!(item.title_color || width) && 200}
                  to={generateLink(item.pageType)}
                >
                  {translate.action_button[language]}
                </Button>
              )}
            </div>
          </SwiperSlide>
        )})}
      </Swiper>
    </section>
  )
}

export default Slide
